// ==============================|| UTILS ||============================== //

export const createAndDispatchCustomEvent = (
  eventType: string,
  eventDetail?: unknown
) => {
  const event = new CustomEvent(eventType, {
    detail: eventDetail
  });
  window.dispatchEvent(event);
};

export enum CustomEventEnum {
  RESERVED_CAPACITY_GUARD_MODE_CHANGED = 'ReservedCapacityGuardModeChanged',
  RESERVED_CAPACITY_GUARDING_ACTION_ACCEPTED = 'ReservedCapacityGuardingActionAccepted',
  RESERVED_CAPACITY_GUARDING_ACTION_REJECTED = 'ReservedCapacityGuardingActionRejected'
}

export enum SseEventEnum {
  RESERVED_CAPACITY_GUARDING_CHECK_REQUESTED = 'ReservedCapacityGuardingCheckRequested',
  RESERVED_CAPACITY_GUARDING_CHECK_COMPLETED = 'ReservedCapacityGuardingCheckCompleted',
  RESERVED_CAPACITY_GUARDING_ACTIONS_UPDATED = 'ReservedCapacityGuardingActionsUpdated'
}
